import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import _ from 'lodash';

import { setProjectOrderLink } from '~features/projects/ducks';

import styles from '~styles/section-nav.scss';
import NavAccordion from './NavAccordion';

import { primaryColor } from '~theme';

import tasklistSVG from '~images/tilauslista_ikoni_sininen.svg';
import tasklistActiveSVG from '~images/tilauslista_ikoni_valkoinen.svg';
import feedbackSVG from '~images/ota_yhteytta_ikoni_sininen.svg';

const SectionNav = ({ home }) => {
  // handleNavigation = navItem => {
  //   // Make sure that when we navigate we end up in the beginning of each form
  //   window.scrollTo(0, 0);

  //   // If the user navigates manually, wipe any linking
  //   if (this.props.projectOrderLink) this.props.setProjectOrderLink(null);

  //   // NOTE: `customContent` tells us that we need to navigate to custom form
  //   // instead of the general form view
  //   if (navItem.customContent) {
  //     // Navigate to custom form that has specific view for it
  //     let serviceName = navItem.customContent;

  //     // If this is needed for more forms, consider refactoring
  //     // If we're on mobile, send the user to the mobile entry point of the
  //     // webshop
  //     if (serviceName === 'tuotteet' && !this.props.isDesktop) {
  //       serviceName += '/mobile';
  //     }
  //     this.props.push(`/palvelut/${serviceName}`);
  //   }
  // };

  const projectOrderLink = useSelector(
    state => state.projects.projectOrderLink
  );
  const navlist = useSelector(state => state.reducer.navlist);
  const appInitialized = useSelector(state => state.reducer.appInitialized);

  const dispatch = useDispatch();

  const resetProjectOrderLink = () => {
    // If the user navigates manually, wipe any linking
    if (projectOrderLink) {
      dispatch(setProjectOrderLink(null));
    }
  };

  let navContent = null;

  const location = useLocation();

  const tasklistActive =
    location.pathname === '/tilauslista' || location.pathname === '/';

  if (!appInitialized) {
    // Show placeholder rows while waiting for nav list items to be received
    navContent = _.range(7).map(i => (
      <PlaceholderNavRow key={`placeholder_row_${i}`}>
        <NavIcon />
        <NavName />
      </PlaceholderNavRow>
    ));
  } else if (navlist) {
    navContent = navlist.map(nav => (
      <div key={nav.id}>
        <SubNav>
          <NavAccordion
            item={nav}
            resetProjectOrderLink={resetProjectOrderLink}
          />
        </SubNav>
      </div>
    ));
  }

  return (
    <Navigation home={home}>
      <h4 className={styles.mainLabel}>
        <span>Tuotteet ja palvelut</span>
      </h4>
      <div className="sideNavContainer">
        <ExtraButton
          to="/tilauslista"
          onClick={resetProjectOrderLink}
          $active={tasklistActive}
        >
          <Dot $active={tasklistActive}>
            <ExtraButtonIcon
              src={tasklistActive ? tasklistActiveSVG : tasklistSVG}
            />
          </Dot>
          Tilauslista
        </ExtraButton>

        {navContent}

        <ExtraButton to="/palaute" onClick={resetProjectOrderLink}>
          <Dot>
            <ExtraButtonIcon src={feedbackSVG} />
          </Dot>
          Ota yhteyttä
        </ExtraButton>
      </div>
    </Navigation>
  );
};

const PlaceholderNavRow = styled.div`
  background-color: #fff;
  height: 65px;
  display: flex;
  align-items: center;
  padding: 0px 15px;
  border-radius: 4px;
  margin-bottom: 4px;
`;
const NavIcon = styled.div`
  background-color: #eee;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  margin-right: 15px;
`;
const NavName = styled.div`
  background-color: #eee;
  border-radius: 4px;
  flex: 1;
  height: 16px;
`;

const ExtraButton = styled(Link)`
  background-color: ${props => (props.$active ? primaryColor : 'white')};
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 3px;
  padding: 8px 20px;

  margin: -5px 4px 14px 4px;
  height: 65px;
  font-size: 1em;
  color: ${props => (props.$active ? 'white' : primaryColor)};

  box-shadow: 0px 3px 6px rgba(173, 170, 173, 0.7);

  &:hover {
    text-decoration: none;
    color: ${props => (props.$active ? 'white' : primaryColor)};
  }
`;

const ExtraButtonIcon = styled.img`
  width: 26px;
  height: 26px;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
`;

const Dot = styled.div`
  position: relative;
  min-width: 50px;
  min-height: 50px;
  background-color: ${props => (props.$active ? primaryColor : 'white')};
  border-radius: 50%;
  border: 2px solid ${props => (!props.$active ? primaryColor : 'white')};
  margin-right: 15px;

  z-index: 1;
`;

const Navigation = styled.div`
  display: block;
  position: relative;
  min-width: 220px;
  margin-top: 20px;
  flex: 0 1 0;

  @media (max-width: 991px) {
    display: ${props => (props.home ? 'block' : 'none')};
    flex: 1 1 0;
  }
`;

const SubNav = styled.div`
  margin: 0;
`;

export default SectionNav;
